import { FlagFragment } from 'src/graphql/generated/graphql'
import { useFlags } from 'src/react_query'

type Flag =
  | 'Awards Page'
  | 'New Navigation'
  | 'Usersnap'
  | 'New Card Editor'
  | 'New Dashboard'
  | 'BulkOrderFlow'
  | 'ActDisplay'
  | 'DoubleBonusDashboard'
  | 'editor_choice'
  | 'can_add_act_addon'

type Flags = {
  awardPage: boolean
  newNavigation: boolean
  userSnap: boolean
  newCardEditor: boolean
  newDashboard: boolean
  bulkOrderFlow: boolean
  actDisplay: boolean
  doubleBonusDashboard: boolean
  editorChoice: boolean
  canAddActAddon: boolean
}

const findFlag = (flags: string[], flag: Flag): boolean =>
  flags.find(item => item === flag) !== undefined

export const useFlag = (flags: FlagFragment[]): Flags => {
  const flagsNames: string[] = flags.map(value => value.name)
  return {
    awardPage: findFlag(flagsNames, 'Awards Page'),
    newNavigation: findFlag(flagsNames, 'New Navigation'),
    userSnap: findFlag(flagsNames, 'Usersnap'),
    newCardEditor: findFlag(flagsNames, 'New Card Editor'),
    newDashboard: findFlag(flagsNames, 'New Dashboard'),
    bulkOrderFlow: findFlag(flagsNames, 'BulkOrderFlow'),
    actDisplay: findFlag(flagsNames, 'ActDisplay'),
    doubleBonusDashboard: findFlag(flagsNames, 'DoubleBonusDashboard'),
    editorChoice: findFlag(flagsNames, 'editor_choice'),
    canAddActAddon: findFlag(flagsNames, 'can_add_act_addon'),
  }
}

// Use this when not using useQueries in the component
export const useFlagsWithUseQueries = (): Flags => {
  const { data: flags } = useFlags({ suspense: true })
  if (!flags) throw Error('Could not retrieve flags')
  return useFlag(flags)
}
